"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InvokeScene = exports.CellValueType = void 0;
var CellValueType;
(function (CellValueType) {
    CellValueType["CELL_IMAGE"] = "cellImage";
})(CellValueType = exports.CellValueType || (exports.CellValueType = {}));
var InvokeScene;
(function (InvokeScene) {
    InvokeScene[InvokeScene["MENU"] = 1] = "MENU";
    InvokeScene[InvokeScene["MENU_ACTION"] = 2] = "MENU_ACTION";
    InvokeScene[InvokeScene["TOOLBAR"] = 3] = "TOOLBAR";
    InvokeScene[InvokeScene["TOOLBAR_ACTION"] = 4] = "TOOLBAR_ACTION";
    InvokeScene[InvokeScene["ADDON"] = 5] = "ADDON";
    InvokeScene[InvokeScene["DOC"] = 6] = "DOC";
})(InvokeScene = exports.InvokeScene || (exports.InvokeScene = {}));
//# sourceMappingURL=interface.js.map